import Highcharts from 'highcharts'
import HighchartsVue from './lib/highchartsVue'
// Highcharts v12 removed the factory-style module init (`Module(Highcharts)`).
// Modules now self-register against the shared Highcharts singleton on import,
// so these must stay as side-effect-only imports placed after the core import.
import 'highcharts/highcharts-3d'
import 'highcharts/modules/exporting'
import 'highcharts/modules/offline-exporting'
import { createApp } from 'vue'
import App from './App.vue'
import { Auth0Plugin, InstallAuth0Plugin } from './auth'
import { auth0Config } from './auth0Config'
import { configureApiClient } from './client/api/configureApiClient'
import { initAnalytics } from './composables/useAnalytics'
import store from './data-store'
import { apiUrl202007 } from './env'
import router from './router'
import 'floating-vue/dist/style.css'
import './css/grid-container.css'
import './css/style.css'
import './css/forms.css'
import './css/eversensor-icons.css'
import 'flatpickr/dist/flatpickr.css'
import mitt from 'mitt'
import { Store } from 'vuex'

const apiClientConfig = {
  BASE: apiUrl202007,
  TOKEN: () => Auth0Plugin.getTokenSilently(),
  HEADERS: { 'Cache-Control': 'private, no-store, max-age=0' }
}

configureApiClient(apiClientConfig)

const emitter = mitt()
const app = createApp(App)

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    emitter: typeof emitter
    $store: Store<any>
  }
}

app.config.globalProperties.emitter = emitter

app.provide('auth', Auth0Plugin)

Highcharts.setOptions({
  colors: ['#00C8FF', '#0d4760', '#ee6a28', '#9519B7', '#046A8B', '#E99C53'],
  lang: {
    thousandsSep: ','
  },
  accessibility: {
    enabled: false
  },
  // Highcharts v13 defaults `palette.colorScheme` to 'light dark', which follows
  // the OS `prefers-color-scheme` and paints charts dark (#141414). The app has
  // a light theme only, so pin the charts to the light palette.
  palette: {
    colorScheme: 'light'
  }
})

app.use(store).use(router).use(InstallAuth0Plugin, auth0Config).use(HighchartsVue)

initAnalytics()

app.mount('#app')
